import { IPrescriptionRequest } from '@alberta/konexi-shared/dist/prescription/prescription-request';
import { Inject, Injectable } from '@angular/core';
import { BaseComponentModel } from 'src/app/common/component-model/base-component-model';
import { ComponentModelDependencies } from 'src/app/common/component-model/component-model-dependencies';
import { ComponentModelInfo } from 'src/app/common/component-model/component-model-info';
import { PrescriptionRequestModelName } from 'src/app/shared/models/model-names';

@Injectable({ providedIn: 'root' })
export class PrescriptionRequestComponentModel extends BaseComponentModel<IPrescriptionRequest> {
  /**
   * ComponentModel for all prescriptionRequest relevant actions and dependencies
   */
  constructor(
    @Inject(ComponentModelDependencies) _componentModelDependencies: ComponentModelDependencies,
    @Inject(ComponentModelInfo) _componentModelInfo: ComponentModelInfo
  ) {
    super(PrescriptionRequestModelName, _componentModelDependencies, _componentModelInfo);
  }
}
